module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-left.5aa3561b.svg";